// Shared defintions for type options
export var usePaddingClasses = padding => {
  var paddings = {
    "2": "p-2",
    "4": "p-2 lg:p-4",
    "8": "p-4 lg:p-8",
    "16": "p-8 lg:p-16"
  };
  return paddings[padding];
};
export var useMaxWidthClasses = max_width => {
  var max_widths = {
    full: "max-w-full",
    prose: "max-w-prose",
    sm: "max-w-screen-sm",
    md: "max-w-screen-md",
    lg: "max-w-screen-lg",
    xl: "max-w-screen-xl",
    "2xl": "max-w-screen-2xl"
  };
  return max_widths[max_width];
};
//# sourceMappingURL=shared-classes.js.map